@if (showEngDetailsLoader()) {
  <section class="loaderwrp">
    <div class="scale-loader">
      <div class="dot-pulse"></div>
    </div>
  </section>
}

<div class="px24-700">
  <form [formGroup]="englishProficiencyDetailsForm">
    @for (ppQuestion of questions; track ppQuestion) {
      <ng-container class="mb44 mb28-700">
        <!-- is english -->
        @if (ppQuestion.displayFormat.value === 'SELECT_BOX' && ppQuestion.mappingField === 'englishIsFirstLanguage') {
          <div class="ques-wrap mb44 mb28-700">
            <label class="d-inline-block mb4">{{ppQuestion.label}}@if (ppQuestion.mandatory === false) {
              <span class="optional-text"> {{optionalText}}</span>
            }</label>
            <mat-chip-listbox class="tag-list" formControlName="{{ppQuestion.mappingField}}"
              id="{{ppQuestion.mappingField}}" [attr.aria-label]="ppQuestion.label">
              @for (optionValue of ppQuestion.options; track optionValue) {
                <mat-chip-option tabindex="0" [aria-label]="ppQuestion.options.option_label" class="tag"
                  id="{{optionValue.option_value}}"
                  [value]="optionValue.option_value"
                  (selectionChange)="onInputChange(ppQuestion.mappingField, optionValue, $event)">
                  {{optionValue.option_label}}
                </mat-chip-option>
              }
            </mat-chip-listbox>
            @if (englishProficiencyDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
              <div class="reg-err">
                {{ppQuestion.helpText}}
              </div>
            }
          </div>
        }
        <!-- Test Type - Show when English is not first language -->
        @if (ppQuestion.mappingField === 'testType' && ppQuestion.questionAttributeId === 2294 && showTestType) {
          <p class="qr-help-text font-bold mb8">{{testDetailsText}}</p>
        }
        @if (ppQuestion.mappingField === 'testType' && ppQuestion.questionAttributeId === 2294 && showTestType && ppQuestion.displayFormat.value === 'SELECT_BOX') {
          <div class="reg-wrap flex flex-column flex-1 mb8">
            <label for="{{ppQuestion.mappingField}}" class="mb4 d-inline-block">{{ppQuestion.label}}@if (ppQuestion.mandatory === false && !englishTestFieldsRequired) {
              <span class="optional-text"> {{optionalText}}</span>
            }</label>
            <mat-form-field
              [ngClass]="englishProficiencyDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted?'slct-boxes relative input-error':'slct-boxes relative'">
              <mat-select formControlName="{{ppQuestion.mappingField}}" id="{{ppQuestion.mappingField}}"
                aria-label="{{ppQuestion.label}}">
                @for (optionValue of ppQuestion.options; track optionValue) {
                  <mat-option
                    [value]="optionValue.option_label"
                    (click)="onInputChange(ppQuestion.mappingField, optionValue)"
                    id="{{optionValue.option_value}}">
                    {{optionValue.option_label}}
                  </mat-option>
                }
              </mat-select>
              @if (englishProficiencyDetailsForm.get(ppQuestion.mappingField)?.value) {
                <button
                  (click)="clearSelection(ppQuestion.mappingField); $event.stopPropagation()"
                  aria-label="Clear selection" type="button" class="select-clear-icon right-52">
                  <img src="./assets/icons/clear.svg" alt="close" width="20" height="20">
                </button>
              }
            </mat-form-field>
            @if (englishProficiencyDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
              <div class="reg-err">
                {{ppQuestion.helpText}}
              </div>
            }
          </div>
        }
        <!-- TEST NAME - OTHER TEST NAME -->
        @if (ppQuestion.mappingField === 'testType' && ppQuestion.questionAttributeId === 2294 && showOtherTestName) {
          <div class="reg-wrap mb8">
            <label for="{{ppQuestion.mappingField}}" class="mb4 d-inline-block">{{otherTestNameText}}</label>
            <mat-form-field>
              <input
                [ngClass]="englishProficiencyDetailsForm.get('otherTestName')?.hasError('required') && submitted ? 'input-error w100':'w100'"
                matInput id="" aria-label="Other test name" formControlName="otherTestName"
                type="text"
                (blur)="onInputString('otherTestName', $event)" (keydown.enter)="preventEnter($event)">
            </mat-form-field>
            @if (englishProficiencyDetailsForm.get('otherTestName')?.hasError('required') && submitted) {
              <div class="reg-err">
                {{enterTestNameText}}
              </div>
            }
          </div>
        }
        <!-- Test Date - Show only when testType is selected and not 'not taken' -->
        @if (ppQuestion.mappingField === 'testTakenDate' && ppQuestion.questionAttributeId === 2305 && showTestDate) {
          <div class="reg-wrap flex flex-column flex-1 padding-fix mb8 relative">
            <div class="relative">
              <label for="picker" class="mb4 d-inline-block">{{ ppQuestion.label }}</label>
              <span class="tooltip inline-flex" [class.active]="showTooltip">
                <span class="cursor-pointer" (click)="toggleTooltip($event)">
                  <img src="./assets/icons/info-icon.svg" alt="info icon" width="20" height="20" />
                </span>
                <div class="tooltip-box absolute">
                  <span class="tooltip-close" (click)="closeTooltip($event)"><img src="./assets/icons/tooltip-close.svg" alt="close" width="20" height="20" /></span>
                  <p class="para-sty">
                    {{infoTooltipText}}
                  </p>
                  <div class="tooltip-arrow absolute"></div>
                </div>
              </span>
            </div>
            <mat-form-field [ngClass]="{'date-error':((invalidTestDate || futureTestDate || (englishProficiencyDetailsForm.get(ppQuestion.mappingField)?.hasError('required'))) && submitted)}" appearance="fill" class="custom-date-wrapper focus-none">
              <input formControlName="{{ppQuestion.mappingField}}" [max]="todayDate" (dateChange)="onDateChange($event, 'testTakenDate')" (keydown.enter)="preventEnter($event)"
                matInput [matDatepicker]="picker" class="date-picker-input"
                placeholder="{{datePlaceholderText}}"
                aria-label="Test taken date" />
              <span matSuffix class="date-suffix-icons">
                @if (englishProficiencyDetailsForm.get(ppQuestion.mappingField)?.value) {
                  <button
                    (click)="clearSelection(ppQuestion.mappingField); $event.stopPropagation()" aria-label="Clear date"
                    type="button" class="date-clear-icon">
                    <img src="./assets/icons/clear.svg" alt="close" width="20" height="20">
                  </button>
                }
                <mat-datepicker-toggle [for]="picker" class="custom-date"></mat-datepicker-toggle>
              </span>
              <mat-datepicker #picker
                panelClass="custom-datepicker">
                <mat-datepicker-actions>
                  <button mat-button matDatepickerCancel
                  class="calendar-btn secondary-btn">{{cancelText}}</button>
                  <button mat-raised-button color="primary" matDatepickerApply
                  class="calendar-btn primary-btn">{{applyText}}</button>
                </mat-datepicker-actions>
              </mat-datepicker>
            </mat-form-field>
            @if (invalidTestDate && submitted) {
              <div class="reg-err">
                {{invalidDateText}}
              </div>
            }
            @if (futureTestDate && submitted && !invalidTestDate) {
              <div class="reg-err">
                {{pastDateText}}
              </div>
            }
            @if (englishProficiencyDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted && !invalidTestDate && !futureTestDate) {
              <div class="reg-err">
                {{ppQuestion.helpText}}
              </div>
            }
          </div>
        }
        <!-- Overall Score - Show only when testType is selected and not 'not taken' -->
        @if (ppQuestion.mappingField === 'overallScore' && ppQuestion.questionAttributeId === 2320 && showOverallScore) {
          <div class="reg-wrap mb8">
            <label for="{{ppQuestion.mappingField}}" class="mb4 d-inline-block">{{ppQuestion.label}}</label>
            <mat-form-field>
              <input
                [ngClass]="(englishProficiencyDetailsForm.get(ppQuestion.mappingField)?.hasError('required') || englishProficiencyDetailsForm.get(ppQuestion.mappingField)?.hasError('min') || englishProficiencyDetailsForm.get(ppQuestion.mappingField)?.hasError('max')) && submitted?'input-error w100':'w100'"
                matInput id="" aria-label="overall score" formControlName="{{ppQuestion.mappingField}}"
                [placeholder]="testScoreConfig !== null ? testScoreConfig?.min + ' - ' + testScoreConfig?.max : 'Enter score'"
                type="number"
                (wheel)="$event.preventDefault()"
                (blur)="onInputString(ppQuestion.mappingField, $event)" (keydown.enter)="preventEnter($event)">
            </mat-form-field>
            @if (englishProficiencyDetailsForm.get(ppQuestion.mappingField)?.hasError('required') && submitted) {
              <div class="reg-err">
                {{ppQuestion.helpText}}
              </div>
            }
            @if (testScoreConfig && (englishProficiencyDetailsForm.get(ppQuestion.mappingField)?.hasError('min') || englishProficiencyDetailsForm.get(ppQuestion.mappingField)?.hasError('max')) && submitted && !englishProficiencyDetailsForm.get(ppQuestion.mappingField)?.hasError('required')) {
              <div class="reg-err">
                {{validScoreBetweenText}} {{testScoreConfig?.min}} {{andText}} {{testScoreConfig?.max}}
              </div>
            }
          </div>
        }
      </ng-container>
    }
    <div class="primary-btn-cnr flex gap12 mt44 mt28-700">
      <button class="secondary-btn" (click)="backButton ()">{{backText}}</button>
      <button class="primary-btn" (click)="nextButton()">{{nextText}}</button>
    </div>
  </form>
</div>

<button class="scroll-top-btn flex items-center justify-center" [class.visible]="showScrollBtnEng" [class.scrolling]="isScrollingEng" [disabled]="isScrollingEng" (click)="scrollToTop()" aria-label="Scroll to top">
  <img src="./assets/icons/arrow-up-icon.svg" alt="Go to top arrow icon" width="24" height="24" />
</button>
